<template>
  <b-overlay :show="loading">
    <section>
      <div>
        <div class="mb-2">
          <h2>Personal Information</h2>
        </div>
        <div>
          <b-card>
            <div class="card-body">
              <validation-observer ref="newUserForm" #default="{invalid}">
                <b-form ref="form" @submit.prevent="onUpdateUser">
                  <div class="mb-2">
                    <b-media class="text-center">
                      <b-avatar ref="previewEl" badge-variant="transparent" :src="avatarPath" :text="avatarText(`${currentUser.first_name} ${currentUser.last_name}`)" :variant="`light-${resolveStatusVariant(getLoanStatusTextForClient(getValueFromSource(currentUser, 'status')))}`" size="10rem">
                        <template #badge>
                          <b-button variant="primary" class="btn-icon rounded-circle" @click="$refs.avatar.$el.childNodes[0].click()">
                            <feather-icon icon="CameraIcon" />
                          </b-button>
                        </template>
                      </b-avatar>
                    </b-media>

                    <div>
                      <b-form-file v-show="false" ref="avatar" accept="image/*" placeholder="" no-drop @input="onImageRenderer" />
                    </div>
                  </div>

                  <!--first name -->
                  <div class="mb-1">
                    <b-form-group label="First Name" label-for="firstname">
                      <validation-provider #default="{ errors }" name="First Name" vid="firstname" rules="required">
                        <div class="custom-input">
                        <span class="leading">
                          <Person />
                        </span>
                          <input id="firstname" v-model="userData.first_name" autocomplete="false">
                        </div>
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </div>

                  <!--last name -->
                  <div class="mb-1">
                    <b-form-group label="Last Name" label-for="lastname">
                      <validation-provider #default="{ errors }" name="Last Name" vid="lastname" rules="required">
                        <div class="custom-input">
                        <span class="leading">
                          <Person />
                        </span>
                          <input id="lastname" v-model="userData.last_name" autocomplete="false">
                        </div>
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </div>

                  <!--Email -->
                  <div class="mb-1">
                    <b-form-group label="Email" label-for="email">
                      <validation-provider #default="{ errors }" name="Email" rules="required|email" vid="email">
                        <div class="custom-input">
                        <span class="leading">
                          <RegistrationMail />
                        </span>
                          <input id="email" v-model="userData.email" autocomplete="false" readonly>
                        </div>
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </div>

                  <!--Phone -->
                  <div class="mb-1">
                    <b-form-group label="Phone" label-for="phone">
                      <validation-provider #default="{ errors }" name="Phone" rules="required" vid="phone">
                        <div class="custom-input">
                        <span class="leading">
                          <RegistrationPhone />
                        </span>
                          <input id="phone" v-model="userData.phone" autocomplete="false">
                          <!-- <span v-if="getValueFromSource(currentUser, 'meta.phone_verified', false)" class="trailing">
                            <small class="text-success">verified</small>
                            <feather-icon class="text-success" icon="CheckCircleIcon" />
                          </span>
                          <span v-else class="trailing">
                            <small class="text-danger">pending </small>
                            <feather-icon class="text-danger" icon="AlertCircleIcon" />
                          </span> -->
                        </div>
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </div>

                  <!--Signature -->
                  <div v-if="!isLabAccount && !isPharmacyAccount" class="mb-1">
                    <b-form-group label-for="hospital-location">
                      <template #label>
                        <span>Signature</span>
                      </template>

                      <div v-if="signaturePath">
                        <b-img :src="signaturePath" fluid thumbnail alt="Medical Professional Signature" style="width: 100px;"></b-img>
                      </div>
    
                      <div v-else class="custom-input">
                        <b-form-input
                          disabled
                          placeholder="No signature uploaded"
                        />
                      </div>
                    </b-form-group>

                    <b-link v-if="signaturePath" @click="$refs.signature.$el.childNodes[0].click()">
                      <feather-icon icon="EditIcon" />
                      <span class="align-middle ml-50">Change Signature</span>
                    </b-link>
                    <b-form-file v-show="false" ref="signature" accept="image/*" placeholder="" no-drop @input="onSignatureImageRenderer" />
                  </div>
                  
                  <div v-if="!signaturePath && !isLabAccount && !isPharmacyAccount" class="mb-1">
                    <b-link @click="$refs.signature.$el.childNodes[0].click()">
                      <feather-icon icon="UploadCloudIcon" />
                      <span class="align-middle ml-50">Upload Signature</span>
                    </b-link>
                    <b-form-file v-show="false" ref="signature" accept="image/*" placeholder="" no-drop @input="onSignatureImageRenderer" />
                  </div>
                  
                  <div>
                    <b-button class="py-1" type="submit" variant="primary" block :disabled="invalid">
                      Update Profile
                    </b-button>
                  </div>
                </b-form>
              </validation-observer>
            </div>
          </b-card>
        </div>
      </div>
    </section>
  </b-overlay>
</template>

<script>
import {
  BCard,
  BForm,
  BMedia,
  BImg,
  BAvatar,
  BButton,
  BOverlay,
  BFormFile,
  BFormInput,
  BLink,
  BDropdown,
  BFormGroup,
  BCardTitle,
  BDropdownItem,
} from "bootstrap-vue";
import { cloneDeep, get } from "lodash";
import { MUTATE_USER_DATA } from "@/store/config/mutation-keys";
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

import Cleave from 'vue-cleave-component';
import Person from '@/assets/svg/Person.svg';
import ResidentialIcon from '@/assets/svg/ResidentialIcon.svg';
import RegistrationMail from '@/assets/svg/RegistrationMail.svg';
import RegistrationPhone from '@/assets/svg/RegistrationPhone.svg';


export default {
  name: "Update",
  components: {
    BCard,
    BForm,
    BMedia,
    BImg,
    Cleave,
    Person,
    BAvatar,
    BButton,
    BOverlay,
    BDropdown,
    BFormFile,
    BCardTitle,
    BFormGroup,
    BFormInput,
    BLink,
    BDropdownItem,
    ResidentialIcon,
    RegistrationMail,
    RegistrationPhone,
    ValidationObserver,
    ValidationProvider,
  },
  data() {
    return {
      loading: false,
      avatarPath: '',
      signaturePath: '',
      updatedSignature: null,
      userData: {},
      cleaveDateOptions: {
        date: true,
        delimiter: '/',
        datePattern: ['Y', 'm', 'd'],
        blocks: [4, 2, 2],
        delimiters: ['-', '-', '-']
      },
    }
  },
  watch: {
    currentUser: {
      handler() {
        this.avatarPath = this.getValueFromSource(this.currentUser, 'avatar.path', '');
        this.signaturePath = this.getValueFromSource(this.currentUser, 'signature.path', '');
      },
      deep: true,
      immediate: true
    },
  },
  created() {
    this.userData = cloneDeep(this.currentUser)
    this.mfa_conf = this.userData.mfa_conf;
  },
  methods: {
    async onUpdateUser() {
      try {
        this.loading = true;

        const formData = new FormData();

        formData.append("first_name", this.userData.first_name);
        formData.append("last_name", this.userData.last_name);
        formData.append("phone", this.userData.phone);

        if (this.updatedImage) {
          formData.append("avatar", this.updatedImage);
        }

        if (this.updatedSignature) {
          formData.append("signature", this.updatedSignature);
        }

        const response = await this.useJwt().authService.updateProfile(formData);
        const updated_user = get(response, 'data.data');
        this.$store.commit(`auth/${MUTATE_USER_DATA}`, updated_user);

        if (this.updatedImage) {
          this.updatedImage = null;
        }

        if (this.updatedSignature) {
          this.updatedSignature = null;
        }
      } catch (error) {
        const error_message = get(error, "response.data.message") || error.message
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Error!',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
            text: error_message
          },
        });
      } finally {
        this.loading = false
      }
    },
    onImageRenderer(file) {
      const reader = new FileReader()

      reader.addEventListener(
          'load',
          () => {
            this.avatarPath = reader.result
            this.updatedImage = file;
          },
          false,
      )

      if (file) {
        reader.readAsDataURL(file)
      }
    },
    onSignatureImageRenderer(file) {
      const reader = new FileReader()

      reader.addEventListener(
          'load',
          () => {
            this.signaturePath = reader.result
            this.updatedSignature = file;
          },
          false,
      )

      if (file) {
        reader.readAsDataURL(file)
      }
    },
  }
}
</script>

<style scoped>

</style>
